module.exports = function () {
  var html = "\n  <div class=\"deck-overlay hide-scrollbar\">\n  </div>";
  return html;
};